import React from 'react';
import PropTypes from 'prop-types';
import InvoiceTextField from '../../../invoiceLinesSlidingPanel/InvoiceTextField';
import { otherFieldsRows, uneditableFields } from '../InvoiceFieldsHelper';
import SovosDatePicker from 's1-ui/sovos-datepicker/SovosDatePicker';

const inputsColumnStyle = { display: 'flex', width: '47.6%', marginLeft: '4.4%' };
const firstColumnStyle = { display: 'flex', width: '48%' };
const emptyErrorMessage = '';

class InvoiceOtherFieldsSection extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { invoiceData } = this.props;
    return (
      <React.Fragment>
        <h1 className="invoice-line-section-title">All other fields</h1>
        {
          otherFieldsRows.map((row, rowIndex) => (
            <div style={ { display: 'flex', flex: 1, marginBottom: 10 } } key={ rowIndex }>
              {
                row.map((field, fieldIndex) => (
                  <div key={ field.key } style={ fieldIndex === 0 ? firstColumnStyle : inputsColumnStyle }>
                    { field.dataType === 'date' ? 
                      <SovosDatePicker
                        name={ field.key }
                        onChange={ (ev, value) => this.props.onFieldChange(field.key, value, emptyErrorMessage) }
                        value={ invoiceData[field.key] }
                        format="YYYY-MM-DD"
                        label="Invoice Date"
                        className="date-picker"
                        style={ { width: '100%' } }
                      /> 
                      :
                      <InvoiceTextField
                        name={ field.key }
                        label={ field.label }
                        value={ invoiceData[field.key] }
                        onChange={ (ev, value, errorMessage) => this.props.onFieldChange(ev, value, errorMessage) }
                        fullWidth={ true }
                        dataType={ field.dataType }
                        disabled={
                          uneditableFields.some(uneditableField => uneditableField === field.key)
                        }
                        stringMaxLength={ field.stringMaxLength || '' }
                      /> 
                    }
                  </div>  
                ))
              }
            </div>
          ))
        }
      </React.Fragment>
    );
  }
}

InvoiceOtherFieldsSection.propTypes = {
  invoiceData: PropTypes.object.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  collapsed: PropTypes.bool.isRequired
};

export default InvoiceOtherFieldsSection;



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/invoiceEditor/invoiceEditorSections/InvoiceOtherFieldsSection.js